module.exports = "<psm-json-editor (jsonChanged)=\"updateConfig($event)\" [json]=\"content\"></psm-json-editor>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/widgets/news/news.widget.html
// module id = ./src/app/views/presentations/widgets/news/news.widget.html
// module chunks = main